import React, { useEffect, useState } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import { useParams } from "react-router-dom";
import LoadingCubes from "../ViewComponents/LoadingCubes";
import ErrorPage from "../../Components/ErrorPage";
import { Dropdown } from "react-bootstrap";
import FormatDateTime from "../../Functions/FormatDate";
import NoDataFoundMex from "../ViewComponents/NoDataFound";
import DeleteRecordModal from "../ViewComponents/DeleteRecordModal";
import NewNetworkModal from "./NewNetorkModal";
import EmptyNetworkModal from "./EmptyNetworkModal";

const MainNetwork = () => {
    const { t } = useLanguage()
    const { project_id } = useParams()
    const user_id = sessionStorage.getItem("user_id")
    const [activeFilter, setActiveFilter] = useState("active");
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [animateReset, setAnimateReset] = useState(false)
    const [records, setRecords] = useState([])
    const [filteredRecords, setFilteredRecords] = useState([])
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecordId, setSelectedRecordId] = useState(null);
    const [netName, setNetName] = useState("")

    const [showIp, setShowIP] = useState(false)

    const no_data_mex = "No IPs found..."
    const title_empty = "Network access"
    const subtitle_empty = "Network access enables connections to this project's resources.";
    const item = "network"

    const ShowIP = () => {
        setShowIP(true)
    }

    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_ips", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, project_id }),
            });
            if (response.ok) {
                const result = await response.json();
                const ipData = result.ips || {};
                const recordsArray = Object.values(ipData);

                setRecords(recordsArray);
                setFilteredRecords(recordsArray);
            } else {
                const errorData = await response.json();
                setError(errorData.message || "Failed to load roles.");
            }
        } catch (err) {
            setLoading(false)
            setError("Failed to connect to the server. Please try again later.");
        } finally {
             setTimeout(() => {
                setLoading(false)
            }, 500);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchRecords();
        } else {
            setError("User ID is missing. Please log in again.");
            setLoading(false);
        }
    }, [user_id]);

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        if (query.trim() === "") {
            setFilteredRecords(records);
            return;
        }

        const filtered = records.filter((ip) => {
            return (
                ip._id.toLowerCase().includes(query) ||
                ip.name.toLowerCase().includes(query) ||
                ip.ip.toLowerCase().includes(query) ||
                FormatDateTime(ip.timestamp).toLowerCase().includes(query)
            );
        });

        setFilteredRecords(filtered);
    };

    const resetFilters = () => {
        setSearchQuery("")
        setActiveFilter("active");
        setAnimateReset(true)
        setTimeout(() => {
            setAnimateReset(false)
        }, 1000);
    };


    const handleDeleteClick = (ipId, networkName) => {
        setSelectedRecordId(ipId);
        setNetName(networkName)
        setShowDeleteModal(true);
    };


    if (loading) {
        return <LoadingCubes />;
    } else if (error) {
        return <ErrorPage />;
    } else if (records.length === 0) {
        return <EmptyNetworkModal fetchRecords={fetchRecords} title={title_empty} subtitle={subtitle_empty} item={item} />
    }

    return (
        <div>
            <div className="work_env_section">
                <div className="header_main_view fade-in">
                    <div className="header_title">
                        <p className="main_view_title">Network access</p>
                        <p className="main_view_subtitle">Allow access to this project from a specific IP</p>
                        <button className="connect_email_btn" onClick={ShowIP}>
                            <i className="fa-solid fa-plus"></i> {t.create}
                        </button>
                    </div>
                </div>
                <div className="filter_container fade-in">
                    <button
                        className={`filter_btn ${activeFilter === "" ? "clicked_filter" : ""}`}
                        onClick={resetFilters}
                    >
                        <i className={`fa-solid fa-arrows-rotate ${animateReset ? "activated_animation" : ""}`}></i>
                    </button>
                    <div className="filter_input_cont">
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input
                            className="filter_input"
                            placeholder={t.search}
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>
                </div>
                <div className="table_container fade-in">
                    {filteredRecords.length === 0 ? (
                        <>
                            <NoDataFoundMex message={no_data_mex} />
                        </>
                    ) : (
                        <>
                            {filteredRecords.map((ip) => (
                                <div key={ip._id} className="api_item">
                                    <p className="table_name">{ip.name}</p>
                                    <p className="table_desc">{ip.ip}</p>

                                    <div className="table_item_footer">
                                        <Dropdown>
                                            <div className="property_btn_action_toggle">
                                                <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="custom-dropdown-menu">
                                                    <Dropdown.Item
                                                        className="drop_down_item delete"
                                                        onClick={() => handleDeleteClick(ip._id, ip.name)}
                                                    >
                                                        <i className="fa-solid fa-trash"></i> {t.delete}
                                                    </Dropdown.Item>

                                                </Dropdown.Menu>
                                            </div>
                                        </Dropdown>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}

                </div>

                <NewNetworkModal
                    show={showIp}
                    handleClose={() => setShowIP(false)}
                    fetchRecords={fetchRecords}
                />

                <DeleteRecordModal
                    show={showDeleteModal}
                    handleClose={() => setShowDeleteModal(false)}
                    recordObject={records.find((record) => record._id === selectedRecordId)}
                    fetchRecords={fetchRecords}
                    endpoint={"delete_ip"}
                    record_type={netName}
                    message="This action CANNOT be undone. It will permanently delete the resource and all associated data."

                />

            </div>
        </div>
    )
}

export default MainNetwork